{
  "code": "es",
  "name": "Español",
  "flag": "🇪🇸"
}
